import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const refundApi = {

    useAdminDashboard : () => {
        return useQuery({
            queryKey: ['admin', 'refund', 'dashboard'],
            queryFn: () => {
                return generalRequest.get(`/admin/refunds/dashboard`);
            }
        })
    },

    useAdminGroupList : (args = {}) => {
        return useQuery({
            queryKey: ['admin', 'refund', 'group', 'search'],
            queryFn: () => {
                return generalRequest.get(`/admin/refunds/groups`, {params: args});
            }
        })
    },

    useAdminCalculateGroupBeforeCreate : (args = {}) => {
        return useQuery({
            enabled: !!(!!args?.start_date && !!args?.end_date),
            queryKey: ['admin', 'refund', 'group', 'calculate', args],
            queryFn: () => {
                return generalRequest.get(`/admin/refunds/groups/calculate`, {params: args});
            }
        })
    },

    useAdminCreateGroup : () => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.post(`/admin/refunds/groups`, args);
            }
        });
    },

    useAdminUpdateGroup : () => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.put(`/admin/refunds/groups/${args?.id}`, args);
            }
        });
    },
    useAdminDeleteGroup : () => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.delete(`/admin/refunds/groups/${args?.id}`);
            }
        });
    },

    useAdminGetRefundGroup : (args = {}) => {
        return useQuery({
            queryKey: ['admin', 'refund', 'get', 'detail', args],
            queryFn: () => {
                return generalRequest.get(`/admin/refunds/groups/${args?.id}`);
            }
        })
    },

    useAdminSearchRefunds : (args) => {
        return useQuery({
            queryKey: ['admin', 'refund', 'search', args],
            queryFn: () => {
                return generalRequest.get(`/admin/refunds`, {params: args});
            }

        })
    }
}








export const useApiSearchStudentRefunds = (args, config) => {
    return useQuery({
        queryKey: ['student', 'refund', 'search', args],
        queryFn: () => ((async (params = {}) => {
            return generalRequest.get(`/student/refunds`, {params: params});
        })(args)),
    })
}




export const useApiGetAdminRefundsDetail = (args, config) => {
    return useQuery({
        enabled: !!args?.id,
        queryKey: ['admin', 'refund', 'get', args],
        queryFn: () => ((async (params = {}) => {
            return generalRequest.get(`/admin/refunds/${params?.id}`)
        })(args)),
    })
}


export const useApiGetStudentRefundsDetail = (args, config) => {
    return useQuery({
        queryKey: ['student', 'refund', 'get', args],
        queryFn: () => ((async (params = {}) => {
            return generalRequest.get(`/student/refunds/${params?.id}`)
        })(args)),
    })
}


export function useApiCreateStudentRefund() {
    return useMutation({
        mutationFn: (data) =>
            ((async (params = {}) => {
                return generalRequest.post(`/student/refunds`, params);
            })(data))
    });
}


export function useApiDeleteStudentRefund() {
    return useMutation({
        mutationFn: (data) =>
            ((async (params = {}) => {
                return generalRequest.delete(`/student/refunds/${params?.id}`);
            })(data))
    });
}


export function useApiPutAdminRefund() {
    return useMutation({
        mutationFn: (data) =>
            ((async (params = {}) => {
                return generalRequest.put(`/admin/refunds/${params?.id}`, params);
            })(data))
    });
}


export function useApiPostAdminRefundExcel() {
    return useMutation({
        mutationFn: (data) =>
            ((async (params = {}) => {
                return generalRequest.post(`/admin/refunds/excel`, params, {responseType: "arraybuffer"});
            })(data))
    });
}